module.exports = __webpack_public_path__ + "static/media/UpgradePlease.4b52131e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/UpgradePlease.gif
// module id = 615
// module chunks = 0